var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFinance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-finance"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.37866 21.2774H23.6214V22.7947H2.37866V21.2774ZM21.3454 8.37996C21.5466 8.37996 21.7396 8.30003 21.8819 8.15775C22.0242 8.01547 22.1041 7.8225 22.1041 7.62129V5.34528C22.104 5.18936 22.0559 5.03725 21.9663 4.90964C21.8767 4.78204 21.75 4.68514 21.6034 4.63213L13.258 1.59744C13.0913 1.53718 12.9088 1.53718 12.7421 1.59744L4.39673 4.63213C4.2501 4.68514 4.12336 4.78204 4.03377 4.90964C3.94417 5.03725 3.89607 5.18936 3.896 5.34528V7.62129C3.896 7.8225 3.97593 8.01547 4.11821 8.15775C4.26049 8.30003 4.45346 8.37996 4.65467 8.37996H5.41334V18.2427H3.896V19.76H22.1041V18.2427H20.5868V8.37996H21.3454ZM5.41334 5.87635L13 3.11478L20.5868 5.87635V6.86262H5.41334V5.87635ZM14.5174 18.2427H11.4827V8.37996H14.5174V18.2427ZM6.93069 8.37996H9.96537V18.2427H6.93069V8.37996ZM19.0694 18.2427H16.0347V8.37996H19.0694V18.2427Z",
    fill: "#4A4A4A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFinance);
export default __webpack_public_path__ + "static/media/icon-finance.3a5f48adf22e0bcba42f4a7f3344109b.svg";
export { ForwardRef as ReactComponent };